/* ---------------------------------------------------------------------
 *                           Import Packages
 * --------------------------------------------------------------------- */

// MUI
import { Tabs, Tab, Typography } from "@mui/material";

/* ---------------------------------------------------------------------
 *                          FromTabs Component
 * --------------------------------------------------------------------- */

/**
 * 定义登录方式标签切换组件
 * @param  {Object} param.mode - 模式（登录 / 注册）
 * @param {Object} param.loginType - 登录类型
 * @param {Function} param.handleLoginTypeChange - 处理登录方式切换的函数
 * @returns 登录方式标签切换组件
 * @function FormTabs
 */
export default function FromTabs({ mode, loginType, onTabChange }) {
  /* ---------------------------------------------------------------------
   *                           Render Component
   * --------------------------------------------------------------------- */

  return (
    <>
      {mode === "login" ? (
        <Tabs
          value={loginType === "message" ? 0 : 1}
          onChange={onTabChange}
          centered
          sx={{
            mb: 6,
            position: "relative",
            "&::after": {
              content: '""',
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              width: "4px",
              height: 32,
              bgcolor: "#e0e0e0",
              borderRadius: 1,
              zIndex: 1,
            },
            "& .MuiTab-root:first-of-type": { mr: 3 },
            "& .MuiTab-root:last-of-type": { ml: 3 },
          }}
        >
          <Tab
            label="短信登录"
            sx={{
              fontSize: 28,
              fontWeight: 600,
              minWidth: 120,
              color: "#222",
              "&.Mui-selected": { color: "#1976d2" },
            }}
          />
          <Tab
            label="密码登录"
            sx={{
              fontSize: 28,
              fontWeight: 600,
              minWidth: 120,
              color: "#222",
              "&.Mui-selected": { color: "#1976d2" },
            }}
          />
        </Tabs>
      ) : mode === "register" ?   (
        <Typography
          align="center"
          sx={{
            mb: 6,
            fontSize: 36,
            fontWeight: 700,
            color: "#1976d2",
            letterSpacing: 2,
          }}
        >
          立即注册
        </Typography>
      ) : (
        <Typography
          align="center"
          sx={{
            mb: 6,
            fontSize: 36,
            fontWeight: 700,
            color: "#1976d2",
            letterSpacing: 2,
          }}
        >
          重设密码
        </Typography>
      )}
    </>
  );
}
